export default {
  dateExtractorExpression: /GMT(?<symbol>\+|-)(?<hours>\d{2})(?<minutes>\d{2})\s\((?<location>.+)\)/,
};
